/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskServiceDetailsRoute } from '@jira/router-routes__servicedesk-services-routes/src/servicedeskServiceDetailsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDetailsWithProjectContext, {
	LazyServicedeskServiceDetailsWithProjectContext,
} from './ui/service-details-with-project-context/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskServiceDetailsRouteEntry: Route = createEntry(
	servicedeskServiceDetailsRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'service-management.service-details',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDetailsWithProjectContext,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			workspaceResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskServiceDetailsWithProjectContext],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
